<template>
  <div class="sort-game">
    <div class="stats">
      <div class="score-board">
        امتیاز:
        <div class="score-board-current">
          <strong>{{ score }}</strong>
        </div>
        اشتباه:
        <div class="score-board-mistake">
          <strong>{{ mistakes }}</strong>
        </div>
      </div>
    </div>

    <div class="conveyor-belt">
      <div
        v-for="(item, index) in items"
        :key="item.id"
        class="clothing-item"
        :class="{ 'active-target': index === 0 }"
        :style="{
          left: item.left + 'px',
          backgroundImage: `url(${item.image})`,
        }"
      >
        <span class="item-label">{{ item.label }}</span>
      </div>
    </div>

    <div class="bins">
      <div
        class="bin white-bin"
        :class="{
          'success-animation': activeBin === 'white',
          'shake-animation': errorBin === 'white',
        }"
        @click="dropTo('white')"
      >
        <img src="@/assets/images/game/box_white.webp" alt="سفید" />
        <p>سفید و روشن</p>
      </div>

      <div
        class="bin color-bin"
        :class="{
          'success-animation': activeBin === 'color',
          'shake-animation': errorBin === 'color',
        }"
        @click="dropTo('color')"
      >
        <img src="@/assets/images/game/box_colors.webp" alt="رنگی" />
        <p>رنگی ملایم</p>
      </div>

      <div
        class="bin dark-bin"
        :class="{
          'success-animation': activeBin === 'dark',
          'shake-animation': errorBin === 'dark',
        }"
        @click="dropTo('dark')"
      >
        <img src="@/assets/images/game/box_jean.webp" alt="تیره" />
        <p>تیره و جین</p>
      </div>
    </div>
    <v-btn v-if="!playing" class="start-btn" @click="startGame">
      <img
        src="@/assets/images/game/start.webp"
        alt="شروع بازی"
        class="btn-image"
      />
    </v-btn>
    <p v-if="gameOverMessage" class="game-over">{{ gameOverMessage }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeBin: null,
      errorBin: null,
      items: [],
      score: 0,
      mistakes: 0,
      playing: false,
      gameOverMessage: "",
      gameInterval: null,
      moveInterval: null,
    };
  },
  methods: {
    startGame() {
      this.score = 0;
      this.mistakes = 0;
      this.items = [];
      this.showPrizeForm = false;
      this.playing = true;
      this.gameInterval = setInterval(this.spawnItem, 2200);
      this.moveInterval = setInterval(this.moveItems, 50);
    },
    spawnItem() {
      if (!this.playing) return;

      const clothes = [
        {
          type: "white",
          label: "لباس سفید",
          image: require("@/assets/images/game/white.webp"),
        },
        {
          type: "color",
          label: "لباس رنگی",
          image: require("@/assets/images/game/colors.webp"),
        },
        {
          type: "dark",
          label: "شلوار جین",
          image: require("@/assets/images/game/jean.webp"),
        },
      ];

      const selected = clothes[Math.floor(Math.random() * clothes.length)];

      this.items.push({
        id: Date.now() + Math.random(),
        type: selected.type,
        label: selected.label,
        image: selected.image,
        left: -150,
        speed: 2 + this.score / 300,
      });
    },

    moveItems() {
      this.items.forEach((item) => (item.left += item.speed * 2));
      if (this.items.length > 0 && this.items[0].left > 800) {
        this.items.shift();
        this.handleMistake();
      }
    },
    dropTo(binType) {
      if (!this.playing || this.items.length === 0) return;

      const targetItem = this.items[0];
      if (targetItem.type === binType) {
        this.score += 30;
        this.activeBin = binType;
        setTimeout(() => (this.activeBin = null), 300);
        this.items.shift();
      } else {
        this.handleMistake(binType);
      }
    },
    handleMistake(binType = null) {
      this.mistakes++;
      if (binType) {
        this.errorBin = binType;
        setTimeout(() => (this.errorBin = null), 400);
      }
      this.items.forEach(
        (i) => (i.image = require("@/assets/images/game/pink.webp")),
      );

      if (this.mistakes >= 3) {
        this.endGame();
      }
    },
    endGame() {
      clearInterval(this.gameInterval);
      clearInterval(this.moveInterval);
      this.playing = false;
      setTimeout(() => {
        this.showPrizeForm = true; // نمایش فرم دریافت شماره
      }, 1000);
    },
    closeTutorial() {
      this.showTutorial = false;
      this.startGame();
    },
  },
  beforeDestroy() {
    clearInterval(this.gameInterval);
    clearInterval(this.moveInterval);
  },
};
</script>

<style scoped>
.sort-game {
  text-align: center;
  padding: 0 15px 15px 15px;
  background: transparent;
  height: 100%;
  text-align: center;
  font-family: "Vazir", system-ui, sans-serif;
  width: 95%;
  max-width: 95%;
  margin: 0 auto;
  width: 95%;
  max-width: 95%;
}
.conveyor-belt {
  position: relative;
  height: 180px;
  border: 3px dashed rgba(23, 124, 23, 0.616);
  background: linear-gradient(to right, #e0e0e002, #f5f5f505);
  backdrop-filter: blur(1px);
  border-radius: 12px;
  overflow: hidden;
  margin: 20px 0;
  margin-top: 5px;
}
.clothing-item {
  position: absolute;
  top: 30px;
  width: 120px;
  height: 120px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: left 0.1s linear;
}
.item-label {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #333;
  font-weight: bold;
}
.bins {
  display: flex;
  justify-content: space-around;
  margin: 14px 0;
  backdrop-filter: blur(1px);
}
.bin {
  width: 28%;
  padding: 15px;
  border: 4px solid;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bin:hover {
  transform: scale(1.05);
}
.bin img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
.white-bin {
  border-color: #e3f2fd;
  background: #f0f8fff1;
  backdrop-filter: blur(2px);
}
.color-bin {
  border-color: #ce93d8;
  background: #f3e5f5f6;
  backdrop-filter: blur(2px);
}
.dark-bin {
  border-color: #424242;
  background: #616161f8;
  backdrop-filter: blur(2px);
  color: white;
}
.stats {
  font-size: 1.1em;
  font-weight: bold;
  color: #f1f5f8;
  margin: 0px;
  text-shadow: #333;
}
.start-button {
  background: #3949ab;
  color: white;
  padding: 14px 10px;
  font-size: 1.3em;
  border: none;
  border-radius: 12px;
  cursor: pointer;
}
.game-over {
  color: #d32f2f;
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 20px;
}
.btn-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  width: 140px;
  height: auto;
  object-fit: contain;
  display: block;
}
.start-btn .btn-image {
  width: 160px;
  height: auto;
  object-fit: contain;
  display: block;
}
.start-btn {
  padding: 12px 40px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1.2em;
  transition: all 0.3s;
  padding: 0;
  min-width: unset;
  border-radius: 12px;
  background: transparent;
  border: none;
  box-shadow: none;
  width: 140px !important;
  margin-bottom: 60px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 1px !important;
}
.score-board {
  display: flex;
  flex-direction: row;
  gap: 3px;
  font-size: 1.1em;
  color: #004aad;
  margin: 0;
  min-height: 50px;
  padding: 0px;
  justify-content: space-between;
  align-items: center;
}
.score-board-mistake {
  background-image: url(~@/assets/images/game/mistake.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 200px;
  font-size: 1em;
  color: #f8fafd;
  margin: 0;
  min-height: 50px;
  padding: 0px;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 8px;
  padding-left: 45px;
}
.score-board-current {
  background-image: url(~@/assets/images/game/score4.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 1em;
  color: #f8fafd;
  margin: 0;
  width: 200px;
  min-height: 50px;
  padding: 0px;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 8px;
  padding-left: 45px;
}
/* انیمیشن لرزش برای سطل‌ها در صورت خطا */
@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-8px) rotate(-3deg);
  }
  50% {
    transform: translateX(8px) rotate(3deg);
  }
  75% {
    transform: translateX(-8px);
  }
  100% {
    transform: translateX(0);
  }
}

.shake-animation {
  animation: shake 0.4s ease-in-out;
  border-color: #ff5252 !important;
}

@keyframes success-pop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.success-animation {
  animation: success-pop 0.3s ease-out;
}
.active-target {
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.8));
  transform: scale(1.05);
}
.stats-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.heart {
  font-size: 1.5rem;
  margin-left: 5px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.modal {
  background: white;
  padding: 30px;
  border-radius: 20px;
  text-align: center;
  width: 80%;
  max-width: 400px;
  direction: rtl;
}
.phone-input {
  width: 100%;
  padding: 12px;
  margin: 20px 0;
  border: 2px solid #ddd;
  border-radius: 10px;
  text-align: center;
  font-size: 1.2rem;
}
.submit-btn {
  background: #4caf50 !important;
  color: white !important;
  width: 100%;
}
.target {
  filter: drop-shadow(0 0 8px gold);
  transform: scale(1.1);
}
</style>
